import React, { useState, useRef, useEffect } from "react"; // 1. Import useRef
import Navbar from "../components/navbar";

import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";

const SplashPdfViewer = () => {
  // 2. Create a reference for the top of the content
  const topRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

const pdfList = [
  {
    id: 1,
    title: "QIP Policy",
    src: "/pdf/about/OurPolicy/Sponsorship-policy-14th-April-2026.pdf",
    isWeb: false,
  },
  {
    id: 2,
    title: "Divyangjan Policy",
    src: "/pdf/about/OurPolicy/TIMSCDR-DRC-Notice.pdf",
    isWeb: false,
  },
  {
    id: 3,
    title: "Energy Conservation, Water Management And Waste Management Policy",
    src: "/pdf/about/OurPolicy/TIMSCDR-Energy-Water-Waste-Notice.pdf",
    isWeb: false,
  },
  {
    id: 4,
    title: "IPR Policy",
    src: "/pdf/about/OurPolicy/IPR-Policy.pdf",
    isWeb: false,
  },
  {
    id: 5,
    title: "NISP Policy",
    src: "/about/nisp-policy",
    isWeb: true,
  },
];






  const [activePdf, setActivePdf] = useState(pdfList[0]);
  const [iframeSrc, setIframeSrc] = useState(null);
  const currentBlobUrl = useRef(null);

  const isPdf = (src) => typeof src === "string" && src.toLowerCase().endsWith(".pdf");

  useEffect(() => {
    if (pdfList[0]) {
      loadPdfInIframe(pdfList[0]);
    }

    return () => {
      if (currentBlobUrl.current) {
        URL.revokeObjectURL(currentBlobUrl.current);
      }
    };
  }, []);

  const loadPdfInIframe = async (pdf) => {
    if (currentBlobUrl.current) {
      URL.revokeObjectURL(currentBlobUrl.current);
      currentBlobUrl.current = null;
    }

    try {
      const response = await fetch(pdf.src, { method: "GET" });
      if (!response.ok) {
        throw new Error(`Failed to load PDF ${pdf.src}: ${response.status}`);
      }

      const contentType = response.headers.get("Content-Type") || "";
      const contentDisposition = response.headers.get("Content-Disposition") || "";
      if (!contentType.includes("application/pdf")) {
        console.warn("PDF response did not return application/pdf:", contentType);
      }
      if (contentDisposition.toLowerCase().includes("attachment")) {
        console.warn("PDF response uses attachment disposition:", contentDisposition);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      currentBlobUrl.current = objectUrl;
      setIframeSrc(objectUrl);
    } catch (error) {
      console.error("PDF load error:", error);
      setIframeSrc(pdf.src);
    }
  };

  const handlePdfSelection = async (pdf) => {
    // Scroll the selected document into view.
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    if (pdf.isWeb) {
      setIsMobileMenuOpen(false);
      window.open(pdf.src, "_blank");
      return;
    }

    setActivePdf(pdf);
    setIframeSrc(null);
    await loadPdfInIframe(pdf);
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal">
        {/* 4. Attach the ref to the header or the first element you want to see */}
        <div ref={topRef}>
          <PageHeader 
            title="Our policies" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Our policies' }]} 
          />
        </div>

        <div className="spv-main-content">
 
          {isMobileMenuOpen && (
            <button
              type="button"
              className="spv-sidebar-overlay"
              aria-label="Close policy documents"
              onClick={() => setIsMobileMenuOpen(false)}
            />
          )}

          <aside className={`spv-sidebar-modern ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <div className="spv-sidebar-topbar">
              <div className="spv-sidebar-header-text">POLICY DOCUMENTS</div>
              <button
                type="button"
                className="spv-mobile-close"
                aria-label="Close policy documents"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                ×
              </button>
            </div>
           
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf?.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area">
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">
                  {activePdf ? activePdf.title : "Select a policy document to preview"}
                </h2>
              </div>
              <div className="spv-action-group">
                <button
                  type="button"
                  className="spv-btn spv-btn-outline spv-mobile-toggle-inline"
                  onClick={() => setIsMobileMenuOpen(true)}
                >
                  Documents
                </button>
                <button
                  className="spv-btn spv-btn-outline"
                  onClick={() => iframeSrc && window.open(iframeSrc, "_blank")}
                  disabled={!iframeSrc}
                >
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                {activePdf ? (
                  <iframe
                    src={iframeSrc || "about:blank"}
                    className="spv-iframe-content secure-frame"
                    title="Institutional Policy"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                ) : (
                  <div className="spv-pdf-placeholder" style={{ padding: "2rem", textAlign: "center", color: "#555" }}>
                    Please select a policy document from the list to preview it here.
                  </div>
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SplashPdfViewer;
